// extracted by mini-css-extract-plugin
export default {"title":"Title_title__6VI0u","h1":"Title_h1__iKZvQ","h2":"Title_h2__Nz+NV","h3":"Title_h3__+XYHE","h4":"Title_h4__U-KA0","h6":"Title_h6__kmXgC","ellipsis":"Title_ellipsis__ikLsx"};